import React from "react"
import PropTypes from "prop-types"

const Icon = ({ name, className, style, color, onClick, alt }) => (
    <span alt={alt || name} style={style} className={`oi oi-${name} text-${color ? color : "black"} ${className}`} onClick={onClick} />
)

Icon.propTypes = {
    name: PropTypes.string.isRequired,
    className: PropTypes.string,
    color: PropTypes.oneOf(["white", "black", "success", "primary", "secondary", "info", "warning", "danger", "light", "dark"]),
    onClick: PropTypes.func,
    style: PropTypes.object
}

export const SvgIcon = ({ name, className, style, onClick, alt, width = "auto", height = "auto" }) => (
    <img alt={alt || name} src={require(`./${name}.svg`)} style={style} width={width} height={height} />
)

export default Icon



// WEBPACK FOOTER //
// ./src/components/simple/Icon/index.js